import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { appcuesService } from "@shared/services/appcues";
import { AppcuesEvents } from "@shared/types/global";

export type GenVersion = "current-gen" | "new-gen";

export const useGenVersionStore = defineStore("gen-version", () => {
  // State
  const _currentGenVersion = ref<GenVersion>("current-gen");

  // Getters
  const currentGenVersion = computed(() => _currentGenVersion.value);
  const isNewGen = computed(() => _currentGenVersion.value === "new-gen");

  // Actions
  const setCurrentGenVersion = (version: GenVersion) => {
    _currentGenVersion.value = version;
    appcuesService.sendEvent(AppcuesEvents.NG_SWITCH, {
      is_ng: version === "current-gen",
    });
  };

  return {
    currentGenVersion,
    isNewGen,
    setCurrentGenVersion,
  };
});
